import { render, staticRenderFns } from "./remote-service-card.vue?vue&type=template&id=455ec2a6&scoped=true"
import script from "./remote-service-card.vue?vue&type=script&lang=js"
export * from "./remote-service-card.vue?vue&type=script&lang=js"
import style0 from "./remote-service-card.vue?vue&type=style&index=0&id=455ec2a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455ec2a6",
  null
  
)

export default component.exports